import { useCallback } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

const HEADER_HEIGHT = 64;

export default function Home() {
  const handleNavClick = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header onNavClick={handleNavClick} />

      <main>
        <HeroSection />
        <CarouselSection />
        <AboutSection />
        <TopicsSection />
        <CommentsSection />
        <AppSection />
        <CardsSection />
        <IndexSection />
        <ContactSection />
        <RankingSection />
        <FeaturesSection />
        <MediaSection />
        <FaqSection />
        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}